module.exports = __webpack_public_path__ + "public/files/img/avatar-s-10.64aa61a3.jpg";